<div class="ui two column vertically padded grid drag-drop-area">
  <div class="header row">
    <div class="ui column center aligned header">SELECTED</div>
    <div class="ui column center aligned header">AVAILABLE</div>
  </div>

  <div class="sortable divided row">
    <div
      id="selected"
      dragula="the-bag"
      class="ui column dragula-bag"
    >
      <div
        *ngFor="let item of ngModel"
        [attr.id]="item.name"
        [class.disabled]="!isEditable(item)"
        class="sortable-item"
      >
        <div class="ui fluid label selected-item" [class.group-by]="canBeGroupedBy">
          <span
            *ngIf="item.meta?.display?.description"
            (click)="showDescription(item)"
            class="info-icon"
          >
            <i class="fa-solid fa-circle-info"></i>
          </span>
          <a *ngIf="canOrderResult && item.isSortable" (click)="onOrderBy($event, item)" class="filter" [class.active]="getOrderState(item)">
            <ng-container [ngSwitch]="getOrderState(item)">
              <i *ngSwitchCase="-1" class="sort amount down icon"></i>
              <i *ngSwitchCase="1" class="vertically flipped sort amount down icon"></i>
              <i *ngSwitchDefault class="sort amount down icon"></i>
            </ng-container>
          </a>
          {{item.displayName}}
        </div>
      </div>
    </div>

    <div class="ui column">
      <item-group-foldout *ngFor="let group of groupArray" [name]="group.name">
        <div id="available" dragula="the-bag" class="dragula-bag">
          <div
            *ngFor="let item of group.items"
            [attr.id]="item.name"
            [class.disabled]="!isEditable(item) || isSelected(item)"
            [class.hidden]="!isVisible(item)"
            class="sortable-item"
          >
            <div class="ui fluid label">
              {{item.displayName}}
            </div>
          </div>
        </div>
      </item-group-foldout>


      <div id="available" dragula="the-bag" class="dragula-bag">
        <div *ngIf="groupArray?.length > 0"  class="ui divider"></div>
        <div
          *ngFor="let item of itemsArray"
          [attr.id]="item.name"
          [class.disabled]="!isEditable(item) || isSelected(item)"
          [class.hidden]="!isVisible(item)"
          class="sortable-item"
        >
          <div class="ui fluid label flex">
            {{ item.displayName }}
            <span
              *ngIf="item.meta?.display?.description"
              (click)="showDescription(item)"
            >
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [header]="dimOrMetric?.name"
  [(visible)]="descriptionVisible"
  dismissableMask="true"
  modal="true"
>
  <p>
    {{ dimOrMetric?.description }}
  </p>
</p-dialog>
